import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=8e3abace&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=8e3abace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3abace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e3abace')) {
      api.createRecord('8e3abace', component.options)
    } else {
      api.reload('8e3abace', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=8e3abace&scoped=true&", function () {
      api.rerender('8e3abace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IJ4vR5LCpPvF/JS/comp/GuestBox.vue"
export default component.exports